import {Component} from 'react';
import {BroadcastEventManager} from '../broadcast/broadcast-event-manager';
import {EventBusManager} from '../local/event-bus-manager';
import {AppEventSymbol, BroadcastEventSymbol} from './symbols';
import {Constructor, EventOptions} from './types';

const hashCode = s => s.split('').reduce((a, b) => (((a << 5) - a) + b.charCodeAt(0)) | 0, 0);

export function AppEvent<T>(options?: EventOptions) {
	return function (ctr: Constructor<T>) {
		if (options?.broadcast) {
			ctr.prototype[BroadcastEventSymbol] = {
				eventID: hashCode(ctr.prototype.constructor.toString()),
			};
		} else {
			ctr.prototype[AppEventSymbol] = true;
		}
	};
}

export function EventHandler<T>(event: Constructor<T>) {
	return function (target: any, propertyKey: string, descriptor: PropertyDescriptor) {
		if (target instanceof Component) {
			const componentDidMount = target.componentDidMount;
			const componentWillUnmount = target.componentWillUnmount;
			const eventBus = new EventBusManager();
			const broadcastEventBus = new BroadcastEventManager();

			target.componentDidMount = () => {
				eventBus.subscribe(event, (args, context) => descriptor.value?.apply(target, args, context));
				if(event[BroadcastEventSymbol]) {
					broadcastEventBus.subscribe(event, (args, context) => {
						descriptor.value?.apply(target, args, context);
					});
				}

				componentDidMount && componentDidMount.apply(target);
			};

			target.componentWillUnmount = () => {
				eventBus.destroy();
				broadcastEventBus.destroy();
				componentWillUnmount && componentWillUnmount.call(target);
			};
		}

		// if(target instanceof )
	};
}
